<template>
  <div>
    <el-container>
      <el-header width="500px" height="100px">
        <el-menu
          default-active="1"
          class="el-menu-demo"
          mode="horizontal">
          <el-menu-item index="1" @click="release">
            <i class="el-icon-s-promotion"></i>
            <span slot="title">ios发布</span>
          </el-menu-item>
          <el-menu-item index="2" @click="record">
            <i class="el-icon-s-order"></i>
            <span slot="title">发布记录</span>
          </el-menu-item>
        </el-menu>
      </el-header>
      <el-main class="main">
        <router-view/>
      </el-main>
    </el-container>
  </div>
</template>

<script>
  import releaseVersion from './version/ReleaseVersion'
  import versionRecord from './version/VersionRecord'

  export default {
    mounted() {
      this.$router.push({'name': 'releaseVersion'})
    },
    name: 'version',
    methods: {
      release() {
        this.$router.push({'name': 'releaseVersion'})
      },
      record() {
        this.$router.push({'name': 'versionRecord'})
      }
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/Version.vue